import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

interface IStylesProps {
  foregroundColor?: string;
}

export default makeStyles<MuiTheme, IStylesProps>((theme: MuiTheme) => ({
  dialogRoot: {
    marginLeft: theme.widthDesktopDrawer,
    marginTop: 64,
    height: "calc(100% - 64px)",

    [theme.breakpoints.down("md")]: {
      marginLeft: theme.widthTabletDrawer
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      marginLeft: 0,
      marginTop: 0,
      height: "100%"
    }
  },
  dialogPaper: {
    boxSizing: "border-box",
    borderLeft: `1px solid ${theme.palette.text.hint}`,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      borderLeft: "none"
    }
  },
  dialogTitle: {
    display: "flex",
    "& .MuiTypography-root": {
      flex: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  },
  dialogTitleLabel: {
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      display: "none"
    }
  },
  dialogTitleCloseButton: {
    marginLeft: 50,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      marginLeft: 0
    }
  },
  facilityName: {
    color: ({ foregroundColor }) =>
      foregroundColor ? `#${foregroundColor}` : theme.palette.text.primary,
    fontSize: 20
  },
  dialogContent: {
    padding: 0
  },
  mapRoot: {
    boxShadow: "0px 1px 7px 0 rgba(0,0,0,0.1)",
    borderRadius: "4px",
    overflow: "hidden",
    position: "relative"
  },
  mapButton: {
    padding: 6
  },
  mapIcon: {
    width: 14,
    height: 14
  },
  wrapper: {
    width: "100%",
    height: 318,
    borderRadius: "0 0 4px 4px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down("sm")]: {
      height: 75
    },
    overflow: "hidden"
  },
  innerWrapper: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  relative: {
    position: "relative"
  },
  tool: {
    zIndex: 1,
    position: "absolute",
    padding: 9,
    borderRadius: 3,
    backgroundColor: "#103827",
    color: theme.palette.secondary.main,
    bottom: 24,
    "&:hover": {
      backgroundColor: "#103827"
    },
    "& .MuiSvgIcon-root": {
      fontSize: 30
    }
  },
  refreshTool: {
    left: 24,
    [theme.breakpoints.down("sm")]: {
      left: 10,
      bottom: 85
    }
  },
  zoomInTool: {
    right: 24,
    bottom: 82,
    [theme.breakpoints.down("sm")]: {
      bottom: 139,
      right: 10
    }
  },
  zoomOutTool: {
    right: 24,
    [theme.breakpoints.down("sm")]: {
      right: 10,
      bottom: 85
    }
  },
  content: {
    flex: "auto",
    height: "100%",
    display: "flex",
    borderRadius: "3px 3px 0 0"
  },
  fullscreen: {
    flex: "auto",
    display: "flex",
    flexDirection: "column",
    padding: 0,
    height: "100%",
    background: "#fff",
    zIndex: theme.zIndex.app.logo + 1,
    borderRadius: 0,
    boxShadow: "none",
    "& $wrapper": {
      flex: "auto",
      height: "auto"
    }
  }
}));
